import axios from "axios";
import { SERVER_URL } from "Constants";
import { IRegistrationEntityAttributes } from "Models/Entities";

/* ========================== Response Type ============================= */
type SaveRegistrationProgressResponse = {
	referringOrganisationId: string;
}

/* ========================== Pre-Registration Check ============================= */
export async function checkEmailAlreadyRegistered(email: string) {
	return await axios.post <boolean>(`${SERVER_URL}/api/entity/RegistrationEntity/check-email`, {
		email: email
	});
}


/* ========================== Registration Progress/Continue ============================= */

export async function checkRegistrationProgress(id: string) {
	return await axios.post(`${SERVER_URL}/api/entity/RegistrationEntity/checkProgress/${id}`);
}

export async function continueRegistration(id: string) {
	return await axios.post<Partial<IRegistrationEntityAttributes>>(`${SERVER_URL}/api/entity/RegistrationEntity/continue`, {
		id: id
	});
}

export async function saveRegistrationProgress(id: string, registrationType: "Client" | "Referral Partner") {
	return await axios.post<SaveRegistrationProgressResponse>(`${SERVER_URL}/api/entity/RegistrationEntity/saveProgress`, {
		id: id,
		registrationType: registrationType
	});
}

/* ========================== Registration PASSCODE ============================= */

export async function confirmRegistrationPasscode(id: string, passcode: string) { 
	await axios.post(`${SERVER_URL}/api/entity/RegistrationEntity/checkPasscode`, {
		id: id,
		passcode: passcode
	});
}